import { useCallback, useContext, useMemo } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Product } from '../../../data/product';
import {
  type StringOption,
  stringOptionsToValues,
  useStringOptions,
} from '../../../helpers/string-options';
import type { Filters } from '../../../hooks/products';
import { MultiSelect } from '../../forms';
import { withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

export const VendorNameFilter = withFilterField(
  'vendorNames',
  function VendorNameFilter({ products }: { products: Product[] }) {
    const { filters, setFilters } = useContext(ProductTableContext);
    const { vendorNames } = filters;

    const allVendorNames = useMemo(() => {
      const vendorNames = new Set<string>();
      for (const product of products) {
        vendorNames.add(product.vendor_name);
      }

      //convert set to array, drop blank items
      return [...vendorNames].filter((vendorName) => vendorName.trim() !== '').sort();
    }, [products]);

    const options = useStringOptions(allVendorNames);
    const value = useStringOptions(vendorNames);

    const onChange = useCallback(
      (vendorNameOptions: readonly StringOption[]) => {
        const vendorNames = stringOptionsToValues(vendorNameOptions);
        setFilters((prev: Filters) => ({ ...prev, vendorNames }));
      },
      [setFilters]
    );

    return (
      <FilterWrapper label="Vendor">
        <MultiSelect
          options={options}
          value={value}
          onChange={onChange}
          placeholder="Any"
          isMulti
        />
      </FilterWrapper>
    );
  }
);
